<template>
  <van-popup
      v-model:show="data.show"
      round
      position="bottom"
      @close="close"
      style="border-radius: 23px 23px 0 0;"
  >
    <div class="content">
      <!--   金币充值&订阅会员商品显示新UI：product_type===3   -->
      <div class="new_title" v-if="monetization === 3 && !isMePage">
        <div class="item_coins_top">
          <p>{{ $t('reader.price') }}:</p>
          <img style="width: 16px;height: 16px;" src="~/assets/images/me/icon-me-coin.svg" alt="">
          <span style="color: #222222;">{{ props.unlockCoin }}</span>
        </div>
        <div class="item_coins_top">
          <p>{{ $t('reader.balance') }}:</p>
          <img style="width: 16px;height: 16px;" src="~/assets/images/me/icon-me-coin.svg" alt="">
          <span style="color: #222222;">{{ userBalance.balance }}</span>
        </div>
        <img class="close_btn" src="~/assets/images/reader/icon-reader-popup-close.svg" alt="" @click="close">
      </div>
      <div class="content_title" v-else>
        <span/>
        <span>{{ $t('reader.top_up_and_unlock') }}</span>
        <img  src="~/assets/images/reader/icon-reader-popup-close.svg" alt="" @click="close">
      </div>

      <div class="p_outside_box">
        <!--   vip产品   -->
        <div class="p_container">
          <div v-for="item in filterVipProducts" :key="item.rsp_id" class="content_vip_card"
               @click="handleClickVip('subscription', item)">
            <!--   金币充值&订阅会员商品显示新UI：product_type===3   -->
            <template v-if="item.product_type === 3">
              <div class="vip_card_left">
                <div class="item_coins_top">
                  <img style="width: 16px;height: 16px;" src="~/assets/images/me/icon-me-coin.svg" alt="">
                  <p>{{ item.coin }}</p>
                  <p>+</p>
                  <p>{{ item.gift_coin }}</p>
                  <p class="unit">Coins</p>
                </div>
                <span>{{ item.description }}</span>
              </div>
              <div class="vip_card_right">
                <!--     有会员价的情况       -->
                <div v-if="item.discount_price" class="vip_card_right_btn">
                  <span class="vip_price"><span style="font-size: 17px;">${{ item.discount_price }}</span><span class="cycle_unit">&nbsp;/{{ formatCycleUnit(item.cycle_unit) }}</span></span>
                  <span style="text-decoration: line-through;font-weight: 500;">&nbsp;${{ item.price }}</span>
                </div>
                <!--     没有会员价的情况       -->
                <div v-else class="vip_card_right_btn">
                  <span class="vip_price"><span style="font-size: 17px;">${{ item.price }}</span><span class="cycle_unit">&nbsp;/{{ formatCycleUnit(item.cycle_unit) }}</span></span>
                </div>
              </div>
              <div v-if="item.badge_text !==''" class="tag_box">
                <p>{{ item.badge_text }}</p>
              </div>
            </template>
            <!--    其余的显示旧UI      -->
            <template v-else>
              <div class="vip_card_left">
                <p>{{ item.name }}</p>
                <span>{{ item.description }}</span>
              </div>
              <div class="vip_card_right">
                <!--     有会员价的情况       -->
                <div v-if="item.discount_price" class="vip_card_right_btn">
                  <span class="vip_price"><span style="font-size: 17px;">${{ item.discount_price }}</span><span class="cycle_unit">&nbsp;/{{ formatCycleUnit(item.cycle_unit) }}</span></span>
                  <span style="text-decoration: line-through;font-weight: 500;">&nbsp;${{ item.price }}</span>
                </div>
                <!--     没有会员价的情况       -->
                <div v-else class="vip_card_right_btn">
                  <span class="vip_price"><span style="font-size: 17px;">${{ item.price }}</span><span class="cycle_unit">&nbsp;/{{ formatCycleUnit(item.cycle_unit) }}</span></span>
                </div>
              </div>
              <div v-if="item.badge_text !==''" class="tag_box">
                <p>{{ item.badge_text }}</p>
              </div>
            </template>
          </div>
        </div>
        <!--   金币产品（V2.3.0：金币档位触发后才显示；/me 页面不显示）   -->
        <div class="content_coins_list" v-if="showCoins && !isMePage">
          <div class="coins_list_item" :class="[data.activeItem === index ? 'active_item' : '']"
               v-for="(item,index) in filterCoinsProducts" :key="item.price"
               @click="handleClick(index, 'order', item)">
            <div class="coins_list_item_top">
              <div class="item_top_coins">
                <img src="~/assets/images/me/icon-me-coin.svg" alt="">
                <span>{{ item.coin }}</span>
              </div>
              <p>+{{ item.gift_coin }} {{ $t('reader.coins') }}</p>
            </div>
            <div class="coins_list_item_bottom" :class="[data.activeItem === index ? 'active_item_bottom' : '']">
              <!--没有折扣价的情况-->
              <div v-if="!item.discount_price">${{ item.price }}</div>
              <!--有折扣价的情况-->
              <div v-else>
                <span>${{ item.discount_price }}</span> /
                <span style="text-decoration: line-through;font-size: 12px">${{ item.price }}</span>
              </div>
            </div>
            <div class="tag_box_bg" v-if="item.gift_coin_percent && item.gift_coin_percent !==''">
              <span>+{{ item.gift_coin_percent }}</span>
            </div>
          </div>
        </div>
        <div class="rules">
          <div class="benefits-title become-vip rules-title">
            {{ $t('me.rules') }}
          </div>
          <p>{{ $t('me.rules_01') }}</p>
          <p>{{ $t('me.rules_02') }}</p>
          <p>{{ $t('me.rules_03') }}</p>
          <p>
            {{ $t('me.rules_04') }}
            <nuxt-link class="red" to="/third-party/user_agreement">{{ $t('me.user_agreement') }}</nuxt-link>
            {{ $t('me.and') }}
            <nuxt-link class="red" to="/third-party/privacy">{{ $t('me.privacy_policy') }}</nuxt-link>
          </p>
        </div>
      </div>
      <van-loading v-if="data.isLoading" class="loading"/>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import {reactive, ref, onMounted} from 'vue'
import {getRechargeProducts} from "../../utils/getRechargeProducts";
import {useLandDataStore} from "../../stores/land";
import eventBus from '../../utils/eventBus'
import {hasCreatedOrder, markRetentionShownToday, retentionShownToday} from "~/utils/payFlags";

const {getPaymentOptions, hasPayermaxChannel} = usePaymentPreload()
const landDataStore = useLandDataStore()
const userBalance = useUserBalanceStore()
const router = useRouter()
const props = defineProps({
  // 弹窗类型，1是vip订阅，2是金币购买
  type: {
    type: Array,
    default: [0, 1]
  },
  unlockCoin: {
    type: Number,
    default: 0
  },
  // V2.3.0 金币档位触发后打开浮层才显示内购金币区（默认隐藏）
  showCoins: {
    type: Boolean,
    default: false
  },
})
const emit = defineEmits(['openPayPopup', 'handleClose', 'coinTierTriggered'])
const data = reactive({
  show: false,
  activeItem: 0,
  productList: {} as any,
  isLoading: false,
  type: 2
})

// cycle_unit 展示映射：weekly=w，monthly=m，yearly=y，daily=d
const cycleUnitMap: Record<string, string> = {
  weekly: 'w',
  monthly: 'm',
  yearly: 'y',
  daily: 'd'
}

const formatCycleUnit = (cycleUnit: string) => {
  return cycleUnitMap[cycleUnit] ?? cycleUnit
}

// 判断是不是/me页面
const isMePage = computed(() => {
  return window.location.href.includes('/me')
})

// 筛选金币产品
const filterCoinsProducts = computed(() => {
  return data.productList?.coin_products?.filter(item => item.retention_type === 0)
})

// 筛选VIP产品
const filterVipProducts = computed(() => {
  return data.productList?.vip_products?.filter(item => item.retention_type === 0)
})

const monetization = computed(() => {
  const deviceType = getDeviceType()
  // 优先从 store 获取
  let result = landDataStore.monetizationObj?.[deviceType]
  if (result !== undefined && result !== null) return result

  // 保底从 localStorage 缓存获取
  if (typeof window !== 'undefined') {
    try {
      const cached = localStorage.getItem('monetization')
      if (cached) {
        const parsed = JSON.parse(cached)
        if (parsed && parsed[deviceType] !== undefined) return parsed[deviceType]
      }
    } catch (e) {
      console.warn('读取 monetization 缓存失败', e)
    }
  }

  // 最终保底：ios 和 android 都返回 0
  return 0
})

// 获取设备类型
const getDeviceType = () => {
  if (typeof window === 'undefined') return 'other'
  const UA = navigator.userAgent.toLowerCase()

  // iOS (iPhone, iPad, iPod)
  if (/iphone|ipad|ipod/i.test(UA)) {
    return 'ios'
  }
  // Mac OS
  if (/mac/i.test(UA) && !/iphone|ipad|ipod/i.test(UA)) {
    return 'mac'
  }
  // Android
  if (/android/i.test(UA)) {
    return 'android'
  }
  // Windows
  if (/win/i.test(UA)) {
    return 'windows'
  }
  return 'other'
}

const handleClickVip = (type: string, product) => {
  emit('openPayPopup', {type, product})
}

const handleClick = (index: number, type: string, product) => {
  data.activeItem = index
  emit('openPayPopup', {type, product})
}

const close = () => {
  data.show = false
  const noOrder = !hasCreatedOrder()
  // V2.3.0 挽留门槛：未创建过订单 且 今天没弹过 才弹（标记在进队列前写，防 @click+@close 双触发重复计数；
  // 多个挽留依次弹算一次，在挽留上充值也算一次）
  if (noOrder && !retentionShownToday()) {
    // 弹窗商品
    const popupProduct = []
    // 获取所有金币挽留商品 (retention_type === 1)
    const coinsProducts = data.productList?.coin_products?.filter((item: any) => item.retention_type === 1) || []
    coinsProducts.forEach((product: any) => {
      popupProduct.push({type: 'SpecialOffer', value: product})
    })
    // 获取所有会员折扣挽留商品 (retention_type === 2)
    const vipProducts = data.productList?.vip_products?.filter((item: any) => item.retention_type === 2) || []
    vipProducts.forEach((product: any) => {
      popupProduct.push({type: 'RechargePopup', value: product})
    })

    // 只有找到产品才触发
    if (popupProduct.length) {
      markRetentionShownToday()
      emit('handleClose', popupProduct)
    }
  }
  // V2.3.0 解锁页金币档位条：未创建过订单，关闭浮层后触发显示（有挽留时在挽留关闭后自然露出）
  if (noOrder) {
    emit('coinTierTriggered')
  }
}

const open = async () => {
  data.show = true
  try {
    // 强制刷新渠道列表 + 拉商品（两者互不依赖，并行发出；串行会让商品列表干等渠道列表一个 RTT）
    const [options, productsRes] = await Promise.all([
      getPaymentOptions(true),
      getRechargeProducts(monetization.value)
    ])
    data.productList = productsRes.data
    data.type = data.productList.vip_products.length ? data.productList.vip_products[0].product_type : 2
    // 仅当渠道列表含 PayerMax 前置组件渠道（google/apple/card）时，才通知预热
    if (!hasPayermaxChannel(options)) return
    // 获取商品后通知 popupHandle 预渲染默认选中商品（金币首个，无则 VIP 首个）
    // 传整个商品：popupHandle 要按 product_type 判断支付类型，session 才能分对桶（订阅/一次性各一份）
    const defaultProduct =
        data.productList?.coin_products?.find((item: any) => item.retention_type === 0) ||
        data.productList?.vip_products?.find((item: any) => item.retention_type === 0)
    if (defaultProduct?.rsp_id) {
      eventBus.emit('warmPayPopup', defaultProduct)
    }

  } catch (e) {
    console.log(e)
  } finally {
    data.isLoading = false
  }
}


defineExpose({
  open,
  close
})
</script>

<style scoped lang="scss">
.content {
  height: 100%;
  min-height: 60vh;
  max-height: 70vh;
  width: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  font-family: SFPro;

  .content_title {
    position: relative;
    width: 100%;
    aspect-ratio: 750 / 120; /* 新图 750×120，等比自适应高度 */
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: 'SFPro', 'SFPro';
    font-weight: 600;
    font-size: 18px;
    color: #222222;
    line-height: 21px;
    text-align: center;
    font-style: normal;
    position: sticky;
    top: 0;
    background: url('~/assets/images/reader/icon-reader-product-bg.svg');
    /* 无左右 padding，容器宽高比严格等于图 750:120，100% 100% 即等比缩放：不拉伸、不压缩 */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    z-index: 2;
    padding-right:19px;
    padding-left: 19px;

    img {
      width: 19px;
      height: 19px;
    }
    span:first-child {
      width: 19px; /* 与右侧关闭按钮等宽占位，space-between 布局下标题精确居中 */
    }
    .close_btn {
        position: absolute;
        top: 14px;
        right: 14px;

      }
  }

  .new_title {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    aspect-ratio: 750 / 120; /* 新图 750×120，等比自适应高度 */
    font-family: 'SFPro', 'SFPro';
    font-weight: 600;
    font-size: 18px;
    color: #222222;
    line-height: 21px;
    text-align: center;
    font-style: normal;
    position: sticky;
    top: 0;
    background: url('~/assets/images/reader/icon-reader-product-bg.svg');
    /* 无左右 padding，容器宽高比严格等于图 750:120，100% 100% 即等比缩放：不拉伸、不压缩、不留白 */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    z-index: 2;

    img {
      width: 19px;
      height: 19px;

      &.close_btn {
        position: absolute;
        top: 14px;
        right: 14px;
      }
    }

    .item_coins_top {
      text-align: left;
      font-family: 'SFPro', 'SFPro';
      font-weight: 500;
      font-size: 16px;
      color: #858C99;
      line-height: 19px;
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 19px 9px;
      padding-bottom: 9px;
      padding-left: 19px; /* 父级 .new_title 已移除左右 padding，左缩进移到内容上 */

      &:nth-child(2) {
        padding-top: 0;
      }

    }
  }

  .p_outside_box {
    padding: 24px 19px;
    padding-top: 0;
    padding-left: 17px;

    .p_container {
      .content_vip_card {
        width: calc(100% + 2px);
        padding: 19px 16px;
        border-radius: 10px;
        background: url('~/assets/images/reader/icon-reader-vip-bg.svg');
        background-size: cover;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        position: relative;

        .tag_box {
          min-width: 0;
          position: absolute;
          top: 0;
          right: 0;
          background: linear-gradient( 270deg,#FF9E2F  0%, #FFB740 100%);
          background-size: 100%;
          background-repeat: no-repeat;
          padding: 2px 8px;
          border-radius: 0 10px 0 10px;
          font-family: D-DIN-PRO, D-DIN-PRO;

          p {
            width: 100%;
            display: block;
            font-size: 12px;
            color: #FFFFFF;
            text-align: center;
            font-weight: 600;
          }
        }

        .vip_card_left {
          color: #FFFFFF;
          flex: 1;

          p {
            font-size: 17px;
            font-weight: bold;
            font-family: 'SFPro', 'SFPro';
            line-height: 20px;
          }

          span {
            font-weight: 400;
            font-size: 11px;
            color: rgba(255, 255, 255, 0.8);
            line-height: 15px;
            text-align: left;
            font-style: normal;
            margin-top: 6px;
            display: block;
            width: 100%;
          }

          .item_coins_top {
            display: flex;
            align-items: center;
            gap: 4px;

            img {
              width: 16px !important;
            }

            span {
              margin-top: 0;
              font-size: 19px;
              font-weight: bold;
            }

            .unit {
              font-weight: 500;
              font-size: 11px;
              color: #FFFFFF;
              line-height: 14px;
              text-align: left;
            }
          }
        }

        .vip_card_right {
          display: flex;
          align-items: center;
          justify-content: center;

          .vip_card_right_btn {
            border-radius: 17px;
            height: 34px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            color: #FFFFFF;
            font-weight: bold;
            line-height: 16px;
            font-size: 14px;
            padding: 4px 0;
            gap: 2px;

            /* 仅命中直接子元素，避免误伤价格行内部包裹的单位 span */
            > span:last-child {
              font-size: 10px;
            }

            .vip_price {
              display: flex;
              align-items: flex-end; /* 价格数字与单位底部对齐 */
              justify-content: center;

              .cycle_unit {
                font-size: 11px;
                font-weight: 500; /* 单位不加粗，与价格 bold 区分 */
                line-height: 11px; /* 行高与字号一致，盒底即文字底，flex-end 才能真实下对齐 */
                transform: translateY(-1px); /* 手动上移 2px，修正视觉对齐偏差 */
              }
            }
          }
        }
      }
    }

    .content_coins_list {
      width: 100%;
      display: flex;
      gap: 11px;
      flex-wrap: wrap;

      .coins_list_item {
        height: 114px;
        background: #FFFFFF;
        border-radius: 14px;
        border: 1px solid #E2E2E2;
        flex: 0 0 calc((100% - 11px) / 2); /* 一行3列，减去2个gap */
        display: flex;
        flex-direction: column;
        position: relative;

        .coins_list_item_top {
          flex: 1;

          .item_top_coins {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 3px;
            margin-top: 28px;

            img {
              width: 16px;
              height: 16px;
            }

            span {
              font-family: 'SFPro', 'SFPro';
              font-weight: 600;
              font-size: 17px;
              color: #FF1979;
              line-height: 20px;
              text-align: left;
              font-style: normal;
            }
          }

          p {
            font-weight: 400;
            font-size: 11px;
            color: #858C99;
            line-height: 14px;
            text-align: center;
            font-style: normal;
            margin-top: 4px;
          }
        }

        .coins_list_item_bottom {
          width: 100%;
          height: 31px;
          border-radius: 0 0 12px 12px;
          background: #F5F6F8;
          font-family: 'SFPro', 'SFPro';
          font-weight: 500;
          font-size: 14px;
          color: #32343A;
          line-height: 31px;
          text-align: center;
          font-style: normal;
        }

        .active_item_bottom {
          background: linear-gradient(180deg, #FE3C8D 0%, #FD6252 100%);
          color: #ffffff;
        }

        .tag_box {
          height: 18px;
          position: absolute;
          top: 0;
          right: 0;

          img {
            width: 44px;
            height: 18px;
          }

          span {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 12px;
            color: #FFFFFF;
            font-family: D-DIN-PRO, D-DIN-PRO;
            font-weight: 600;
          }
        }

        .tag_box_bg {
          min-width: 0;
          position: absolute;
          top: -1px;
          right: -1px;
          background: linear-gradient( 270deg, #FE3E89 0%, #FD6154 100%);
          padding: 2px 8px;
          border-radius: 0 10px 0 10px;
          font-size: 12px;
          color: #FFFFFF;
          text-align: center;
          font-weight: 600;
          font-family: D-DIN-PRO, D-DIN-PRO;
        }
      }

      .active_item {
        border-color: #FF1979;
      }
    }

    .rules {
      color: #84848A;

      .red {
        color: #1877f2;
        text-decoration: underline;
      }

      .rules-title {
        display: flex;
        gap: 10px;
        align-items: center;
        margin-top: 16px;
        margin-bottom: 10px;
        color: #32343A;
      }

      .vertical_line {
        width: 4px;
        height: 14px;
        background: #212121;
        border-radius: 2px;
      }

      p {
        margin-bottom: 15px;
      }
    }


  }

  .loading {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
